// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// IE11 fixes
import "babel-polyfill";
import "intersection-observer";

// jquery
window.$ = window.jQuery = require('jquery')

// lodash
window._ = require('lodash');

// sweetalert2
// window.swal = require('sweetalert2')
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css'
window.Swal = swal

// idleJs
window.idleJs = require('idle-js')

// vue, vuetify
import Vue from 'vue'
import vuetify from './plugins/vuetify' // path to vuetify export

// jsonp
import { VueJsonp } from 'vue-jsonp'
Vue.use(VueJsonp)

// emoji
window.emojioneVersion = "2.2.7";
window.emojionarea = require('emojionearea');
import 'emojionearea/dist/emojionearea.min.css'
import emoji from './js/emoji'
Vue.use(emoji);

// Progress Bar
import VueProgressBar from 'vue-progressbar'
const options = {
  color: '#ff9800',
  failedColor: '#874b4b',
  thickness: '3px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  inverse: false
}
Vue.use(VueProgressBar, options);

// vue social
import SocialSharing from 'vue-social-sharing'
Vue.use(SocialSharing);

// vue toast
import Toastr from 'vue-toastr';
Vue.component('vue-toastr', Toastr);

// vue resource
import VueResource from 'vue-resource'
Vue.use(VueResource);
Vue.http.options.credentials = true;
Vue.http.options.xhr = {withCredentials: true};
Vue.http.options.emulateJSON = true;

import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

import VueSessionStorage from "vue-sessionstorage";
Vue.use(VueSessionStorage);

import VueScrollTo from 'vue-scrollto';
Vue.use(VueScrollTo);

import VueTypedJs from 'vue-typed-js'
Vue.use(VueTypedJs)

import VueObserveVisibility from 'vue-observe-visibility'
Vue.use(VueObserveVisibility)

// animations
require('./lib/js/css3-animate-it')
require('./lib/css/animations.css')
require('./lib/css/animations-ie-fix.css')
require('./lib/css/magic.css')
import 'animate.css';

import directives from './js/directives' // sembra che nn viene usato ma invece serve!
import router from './js/router'
import store from './store'
import Config from "../config-app/config";

import * as types from './store/mutations-types'
import {auth, authShared} from '../config-firebase/firebase'
import { onAuthStateChanged } from "firebase/auth";

// Vue init
// Vue.config.productionTip = false
import App from './App.vue'
var firstRun = true;

// see doc: https://firebase.google.com/docs/auth/web/manage-users#web-version-9
// const auth = getAuth();

// si occupa esclusivamente del sync nello stato
// in Vue.app faccio redirect al cambio di stato (ho un watch su user_uid)
// in router faccio redirect solo come safeguard
onAuthStateChanged(authShared, (user) => {
  // console.log('onAuthStateChanged', user)
  if (user) {
    store.dispatch("setUser", user);
  } else {
    store.dispatch("clearUser");
  }

  if (firstRun) {
    new Vue({
      vuetify,
      // Attach the Vue instance to the window so it's available globally.
      created: function () {
        window.Vue = this
      },
      store,
      router,
      render: h => h(App)
    }).$mount('#app')

    firstRun = false;
  }

  // remove this listener so that we aren't trying to make new vue objects
  // every time the auth state changes.
  // unsubscribe()
});


Vue.config.devtools = process.env.NODE_ENV !== 'production'
Vue.config.debug = process.env.NODE_ENV !== 'production'
Vue.config.silent = process.env.NODE_ENV === 'production'

// if (process.env.NODE_ENV === 'production') {
//   console.log = function () {
//   }
// }
